import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiZap, FiShield, FiUsers, FiStar, FiActivity } = FiIcons;

const StepCard = ({ number, title, sub, desc }) => (
  <div className="bg-[#0B0E14] border border-gray-700 rounded-2xl p-5 mb-4 flex items-start gap-4">
    <div className="flex-shrink-0 w-8 h-8 bg-white rounded-full flex items-center justify-center text-black font-bold text-sm">
      {number}
    </div>
    <div className="text-left">
      <h3 className="text-white font-bold text-lg leading-tight">{title}</h3>
      <p className="text-gray-400 text-sm mt-1 leading-snug">
        {sub} <span className="text-gray-500">{desc}</span>
      </p>
    </div>
  </div>
);

const TrustPill = ({ icon, text, colorClass = "text-white" }) => (
  <div className="border border-gray-600 rounded-full py-3 px-4 flex items-center justify-center gap-2 bg-[#0B0E14]">
    <SafeIcon icon={icon} className={`${colorClass} text-lg`} />
    <span className="text-white font-semibold text-sm">{text}</span>
  </div>
);

const LandingClone = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans flex flex-col items-center py-12 px-4">
      
      {/* Header Section */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center w-full max-w-md mx-auto mb-8"
      >
        <h1 className="text-5xl font-extrabold mb-6 tracking-tight">Quit Today</h1>
        
        <div className="inline-flex items-center gap-2 bg-white text-black px-6 py-2 rounded-full font-bold text-sm mb-8">
          <SafeIcon icon={FiCheck} /> Recovery Community
        </div>

        <h2 className="text-2xl font-bold mb-2">Quit your addiction today</h2>
        <p className="text-gray-300 font-medium">by following these easy steps</p>
      </motion.div>

      {/* Steps Section */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="w-full max-w-md mx-auto text-center"
      >
        <div className="flex flex-col items-center mb-6">
          <div className="flex items-center gap-2 text-white font-bold mb-1">
            <SafeIcon icon={FiZap} /> 3 Easy Steps
          </div>
          <div className="w-16 h-0.5 bg-gray-700"></div>
        </div>

        <StepCard 
          number="1"
          title="Click To Change Your Life"
          sub="Hit the button below →"
          desc="Begin your journey to quitting porn"
        />
        
        <StepCard 
          number="2"
          title="Download QUITTR App"
          sub="Get our partner app QUITTR -"
          desc="quit your addiction today"
        />
        
        <StepCard 
          number="3"
          title="Build Healthy Habits"
          sub="By following our comprehensive guide"
          desc="your life will begin to change"
        />

        {/* Pro Tip Box */}
        <div className="bg-[#0B0E14] border border-gray-700 rounded-2xl p-5 mb-8 text-left">
          <div className="flex items-center gap-2 text-white font-bold mb-2">
            <SafeIcon icon={FiZap} /> PRO TIP: Maximize Results
          </div>
          <p className="text-gray-400 text-sm leading-snug">
            Signup for the free trial to gain access to a whole world of change.
          </p>
        </div>

        {/* CTA Button */}
        <button className="w-full bg-white text-black rounded-full py-4 font-extrabold text-lg flex items-center justify-center gap-2 hover:bg-gray-100 transition-colors mb-4">
          <SafeIcon icon={FiCheck} /> Change Your Life Today
        </button>

        <p className="text-gray-400 text-sm mb-8">50K+ members recovering daily</p>

        {/* Trust Badges Grid */}
        <div className="grid grid-cols-2 gap-3 w-full">
          <TrustPill icon={FiShield} text="100% Secure" colorClass="text-green-500" />
          <TrustPill icon={FiActivity} text="Helpful Change Habits" colorClass="text-green-500" />
          <TrustPill icon={FiUsers} text="50K+ Users" />
          <TrustPill icon={FiStar} text="4.7★ Rating" />
        </div>

      </motion.div>
    </div>
  );
};

export default LandingClone;